import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=0b778a86&"
import script from "./Price.vue?vue&type=script&lang=ts&"
export * from "./Price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b778a86')) {
      api.createRecord('0b778a86', component.options)
    } else {
      api.reload('0b778a86', component.options)
    }
    module.hot.accept("./Price.vue?vue&type=template&id=0b778a86&", function () {
      api.rerender('0b778a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/Price.vue"
export default component.exports